import { VehicleDataAge } from '@agilox/common';
import { VehicleDataActuality } from '../interfaces/vehicle-data-actuality.interface';

export const UP_TO_DATE_VEHICLE_DATA: VehicleDataActuality = {
	level: VehicleDataAge.UP_TO_DATE,
	affectedVehicles: [],
	affectedDataTypes: [],
	totalVehicles: 0,
};
